import React, { Component } from 'react';
import ModalOverlay from "../../../../components/UI/ModalOverlay";
import theme from '../../../../Theme/theme';
import Button from '../../../../components/UI/Button';
import TextBox from "../../../../components/TextBox";
import axios from "axios";
import { toast } from "react-toastify";
import { API_URL } from "config/constants";
import { Constants } from '../../../../common/constants';
import { isValidEmail } from '../../../../common/Utils';
import { ERROR_HANDLE } from '../../../../config/constants';

const TITLE_EDIT_ADMIN = "EDIT ADMIN";
const TITLE_ADD_ADMIN = "ADD ADMIN";
const LABEL_NAME = "Name";
const LABEL_EMAIL = "Email";
const LABEL_USER_NAME = "UserName";
const LABEL_PASSWORD = "Password";
const LABEL_ACCESS_LEVEL = "Access Level";
const DONE_TEXT = "SAVE";
const CLOSE_TEXT = "CLOSE"

/**
 * An component used to present Modal to add/edit the admin user.
 */
export default class AddAdmin extends Component {

    constructor(props) {
        super(props);
        this.editDetails = this.props.editDetails;
        if (this.editDetails) {
            this.state = {
                name: this.editDetails.name,
                username: this.editDetails.username,
                email: this.editDetails.email,
                access_level: this.editDetails.access_level,
                password: '',
                error: '',
            }
        } else {
            this.state = {
                name: '',
                username: '',
                email: '',
                access_level: '',
                password: '',
                error: '',
            }
        }
    }

    onChangeValue = (key, event) => {
        let values = { ...this.state };
        values[key] = event.target.value;
        values.error = "";
        this.setState(values);
    }

    render() {
        let { editDetails } = this.props;
        return (
            <ModalOverlay
                modalStyle={style.modalStyle}
                header={editDetails ? TITLE_EDIT_ADMIN : TITLE_ADD_ADMIN}
                headerStyle={style.headerStyle}
                headerBodyStyle={style.headerBodyStyle}
                bodyStyle={style.modalBody}
                underLayerStyle={style.underLayer}
                close={this.props.close}>
                <div style={style.selectorWrapper}>
                    <p style={style.selectorLabel}>{LABEL_NAME}</p>
                    <TextBox
                        style={style.input}
                        value={this.state.name}
                        onChange={(event) => {
                            this.onChangeValue("name", event);
                        }}
                    />
                </div>
                {!editDetails && <div style={style.selectorWrapper}>
                    <p style={style.selectorLabel}>{LABEL_EMAIL}</p>
                    <TextBox
                        type="email"
                        style={style.input}
                        value={this.state.email}
                        onChange={(event) => {
                            this.onChangeValue("email", event);
                        }}
                    />
                </div>}
                <div style={style.selectorWrapper}>
                    <p style={style.selectorLabel}>{LABEL_USER_NAME}</p>
                    <input
                        id="admin_user_name"
                        name="admin_user_name"
                        className="input_TextBox"
                        style={style.input}
                        placeholder={LABEL_USER_NAME}
                        value={this.state.username}
                        onChange={(event) => {
                            this.onChangeValue("username", event);
                        }}
                    />
                </div>
                {!editDetails && <div style={style.selectorWrapper}>
                    <p style={style.selectorLabel}>{LABEL_PASSWORD}</p>
                    <input
                        id="admin_password"
                        name="admin_password"
                        className="input_TextBox"
                        autocomplete="new-password"
                        style={style.input}
                        type='password'
                        placeholder={LABEL_PASSWORD}
                        value={this.state.password}
                        onChange={(event) => {
                            this.onChangeValue("password", event);
                        }}
                    />
                </div>}
                <div style={style.selectorWrapper}>
                    <p style={style.selectorLabel}>{LABEL_ACCESS_LEVEL}</p>
                    <select
                        style={{ flex: 1 }}
                        id="access-options"
                        className="input_TextBox"
                        value={this.state.access_level}
                        onChange={(event) => {
                            this.onChangeValue("access_level", event);
                        }}>
                        <option value="" selected disabled hidden>Choose here</option>
                        {Object.keys(Constants.ADMIN_ACCESS_LEVELS).map((key) => {
                            const value = Constants.ADMIN_ACCESS_LEVELS[key];
                            return <option value={value} >{"TIER_"}{value}</option>
                        })}
                    </select>
                </div>
                <p style={style.txtError}>{this.state.error}</p>
                <div style={style.doneButtonWrapper}>
                    <Button
                        style={style.doneButton}
                        type="primary"
                        onClick={this.save}>
                        {DONE_TEXT}
                    </Button>
                    <Button
                        style={style.closeButton}
                        type="primary"
                        onClick={this.props.close}>
                        {CLOSE_TEXT}
                    </Button>
                </div>
            </ModalOverlay>
        )
    }

    save = () => {
        let { name, username, email, access_level, password } = this.state;
        if (!name || !username || !email || !access_level || !this.editDetails && !password) {
            this.setState({ error: "Please fill all the details." })
        } else if (!isValidEmail(email)) {
            this.setState({ error: "Please enter a valid email" })
        } else if (!this.editDetails && password.length < 6) {
            this.setState({ error: "Password should be minimum 6 alphanumeric letters." })

        } else {
            access_level = parseInt(access_level);
            var toastId = toast("Saving details...")
            let url = `${API_URL}/admin/`;
            let method, data;
            if (this.editDetails) {
                url = url + this.state.email;
                method = 'PUT';
                data = { name, username, access_level };
            } else {
                method = 'POST';
                data = { name, username, email, access_level, password };
            }
            axios({
                url,
                method: method,
                headers: {
                    "x-access-token": localStorage.getItem("access_token")
                },
                data
            }).then(res => {
                toast.dismiss(toastId);
                if (!res.data.error) {
                    this.props.close();
                    setTimeout(() => {
                        this.props.onUpdate();
                    }, 500);
                } else
                    ERROR_HANDLE(res.data.error);
            }).catch(err => {
                toast.dismiss(toastId);
                ERROR_HANDLE(err);
            });
        }
    }
}

const style = {
    modalStyle: {
        backgroundColor: theme.color.white,
        borderRadius: 3
    },
    underLayer: {
        backgroundColor: theme.color.shadowColor
    },
    headerStyle: {
        display: "flex",
        justifyContent: "center",
        alignItems: "flex-start",
        backgroundColor: theme.color.transparent
    },
    headerBodyStyle: {
        width: "100%",
        height: 40,
        fontSize: 25,
        letterSpacing: 0,
        borderRadius: 3,
        lineHeight: "40px",
        fontFamily: theme.font.avenirBlackOblique,
        color: theme.color.thickGrey,
    },
    modalBody: {
        margin: 25,
        marginTop: 0,
        borderRadius: "0px 0px 15px 15px",
        backgroundColor: theme.color.transparent
    },
    doneButtonWrapper: {
        width: "400",
        display: "flex",
        justifyContent: "space-around",
        marginTop: 20
    },
    doneButton: {
        width: "160px",
        fontSize: "20px"
    },
    closeButton: {
        width: "160px",
        fontSize: "20px",
        marginLeft: "20px"
    },
    selectorWrapper: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexWrap: "nowrap",
        height: 70
    },
    selectorLabel: {
        fontSize: "22px",
        color: "#444445",
        marginRight: "15px",
        width: "150px",
        textAlign: "left",
        height: 20
    },
    input: {
        flex: 1,
        border: "1px solid #444445",
        borderRadius: 50,
        fontSize: 18,
        color: theme.color.primaryBlue,
        padding: 10,
        paddingLeft: 20,
        textAlign: "left",
        backgroundColor: theme.color.textLightWhite
    },
    txtError: {
        marginTop: 10,
        color: 'red'
    }
}